// Clinical, calm theme for the patient portal. Distinct from the consumer
// (wellness) theme and the support/clinic operator themes — see docs/PATIENT_PORTAL_PLAN.md §7.
// Cream background, ink-blue primary, sage accents, warm-coral for urgency.

export const patientTheme = {
  color: {
    bg: '#FAF7F2',
    bgRaised: '#FFFFFF',
    bgSubtle: '#F4F0E9',
    border: '#E6E0D6',
    borderStrong: '#D5CCBC',

    ink: '#1F2937',
    inkSoft: '#4B5563',
    inkMuted: '#6B7280',

    primary: '#1F3A5F',
    primaryHover: '#15294A',
    primarySoft: '#E8EEF6',

    accent: '#6B9080',
    accentSoft: '#E1ECE7',

    urgent: '#C24D49',
    urgentSoft: '#FBEAE9',

    success: '#3F7D58',
    warning: '#B97A2A',

    overlay: 'rgba(31, 41, 55, 0.55)',
  },
  radius: {
    sm: '6px',
    md: '12px',
    lg: '20px',
    pill: '999px',
  },
  shadow: {
    card: '0 1px 2px rgba(31,41,55,0.04), 0 4px 12px rgba(31,41,55,0.04)',
    raised: '0 4px 16px rgba(31,41,55,0.08)',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  type: {
    family: "'Outfit', -apple-system, system-ui, sans-serif",
    body: '15px',
    bodyLg: '17px',
    title: '22px',
    titleLg: '28px',
    titleXl: '34px',
  },
  layout: {
    leftRailWidth: '260px',
    leftRailCollapsedWidth: '76px',
    topBarHeight: '64px',
    bottomNavHeight: '64px',
    contentMaxWidth: '1080px',
  },
  motion: {
    quick: '120ms ease-out',
    standard: '200ms ease-out',
  },
  z: {
    topBar: 30,
    leftRail: 25,
    bottomNav: 30,
    overlay: 50,
    modal: 60,
  },
}

export default patientTheme
